import request from '@/utils/request'


const BASE_URL = '/public'

export function login(data) {
  return request({
    url: `${BASE_URL}/login`, // 强制指向直通车
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: `${BASE_URL}/info`, // 强制指向直通车
    method: 'get'
  })
}

// 注册接口 (虽然 Register.vue 自己写了，这里也改一下以防万一)
export function register(data) {
  return request({
    url: `${BASE_URL}/register`,
    method: 'post',
    data
  })
}

// 下面这些非核心接口暂时保持不动，或者按需修改
export function updateInfo(data) { return request({ url: '/user/updateInfo', method: 'put', data }) }
export function updatePassword(data) { return request({ url: '/user/changePwd', method: 'put', data }) }
export function logout() { return request({ url: '/user/logout', method: 'get' }) }
export function getUserList(){ return request({ url: '/user/list', method: 'get' }) }
